import { render, staticRenderFns } from "./WxRecharge.vue?vue&type=template&id=70d537f3&scoped=true&"
import script from "./WxRecharge.vue?vue&type=script&lang=js&"
export * from "./WxRecharge.vue?vue&type=script&lang=js&"
import style0 from "./WxRecharge.vue?vue&type=style&index=0&id=70d537f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d537f3",
  null
  
)

export default component.exports